import script from "./instanceCommons.vue?vue&type=script&lang=js"
export * from "./instanceCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__